import {EventEmitter} from '@angular/core'

export class DialogComponentMock {
  onConfirm = new EventEmitter<boolean>(true)
  onDismiss = new EventEmitter<boolean>(true)
  onClose   = new EventEmitter<boolean>(true)

  public configure(configs: {}) {}
  public open() {}
}



// WEBPACK FOOTER //
// ./src/app/shared/tests/dialog.component.mock.ts